import { Box, Card, checkboxClasses, TableContainer } from '@mui/material';
import { styled } from '@mui/system';

const FilesContainer = styled(TableContainer)(({ theme }) => ({
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
}));

const FileCard = styled(Card)(({ theme }) => ({
    width: '226px',
    height: 'fit-content !important',
    boxShadow: 'none',
    position: 'relative',
    borderRadius: theme.spacing(3),
    border: `1px solid ${theme.palette.common.lightgray}`,
    background: theme.palette.common.lightblue
}));

const FileCardMobile = styled(Card, { shouldForwardProp: prop => prop !== 'smallMobile' })(({ theme, smallMobile }) => ({
    width: '100%',
    height: 'fit-content !important',

    display: 'flex',
    boxShadow: 'none',
    position: 'relative',
    borderRadius: theme.spacing(smallMobile ? 0 : 3),
    border: `1px solid ${theme.palette.common.lightgray}`,
    background: theme.palette.common.lightblue,
    [`& #more-options`]: {
        background: 'transparent',
        '&:hover': {
            background: theme.palette.common.white
        }
    }
}));

const FolderImage = styled(Box, { shouldForwardProp: prop => prop !== 'mobile' && prop !== 'smallMobile' })(({ theme, smallMobile, mobile }) => ({
    height: mobile ? '100%' : '122px',
    width: '100%',
    borderRadius: mobile && !smallMobile ? theme.spacing(3) : 'none',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.disabled.main,
    cursor: 'pointer'
}));

const FileActionBox = styled(Box)(({ theme }) => ({
    position: 'absolute',
    display: 'flex',
    bottom: theme.spacing(4),
    gap: theme.spacing(3),
    width: '100%',
    justifyContent: 'center',
    [`& .${checkboxClasses.root}`]: {
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1)
    }
}));

export { FileActionBox, FileCard, FileCardMobile, FilesContainer, FolderImage };
